Vue.component('dogTags', {
  template: templates.dogTags,
  data() {
    return {
      model: {
        tags: []
      }
    }
  },
  mounted() {
    const c = this;
    c.getDogTags();
  },
  methods: {
    getDogTags() {
      const c = this;

      userService.getDogTags()
        .then(function (response) {
          c.model.tags = response.data;
        })
        .catch(function (error) {
          
        });
    },
  }
});